import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterAdminUserView.
 * @extends JetView
 */
export default class FilterAdminUserView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Login',
                            label: "<span class='icon-mail'></span>" + _('Usuario'), // User label
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for adding user filter
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('Usuario'), // Placeholder for user input
                            invalidMessage: _('Usuario is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for adding user ID filter
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder for user ID input
                            invalidMessage: _('ID Usuario is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for date selection
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date picker label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for date picker
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Partner',
                            label: _('Partner'), // Partner label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for partner selection
                            value: profile.PartnerSelected, // Default selected partner
                            options: profile.Partners, // Partner options
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'FirstName',
                            label: "<span class='icon-user'></span>" + _('Primer nombre'), // First name label
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for adding first name filter
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('Primer Nombre'), // Placeholder for first name input
                            invalidMessage: _('Primer Nombre is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Email',
                            label: "<span class='icon-mail'></span>" + _('Email'), // Email label
                            labelPosition: 'top',
                            placeholder: _('Email'), // Placeholder for email input
                            invalidMessage: _('Email is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'City',
                            label: "<span class='icon-language'></span>" + _('Ciudad'), // City label
                            labelPosition: 'top',
                            placeholder: _('Ciudad '), // Placeholder for city input
                            invalidMessage: _('Ciudad is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'City',
                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'), // Currency label
                            labelPosition: 'top',
                            placeholder: _('Moneda'), // Placeholder for currency input
                            invalidMessage: _('Moneda is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'ClientCategory',
                            localId: 'clientCategory:combo',
                            label: _('Categoría cliente'), // Client category label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for client category selection
                            options: [], // Options for client category
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with user filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            height: screen.width < 500 ? 500 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Left section with additional filters
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Accordion starts collapsed
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Body containing upper section 2
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Añadir Usuario'), // Add user button
                            type: 'form',
                            hidden: !devConfig.getPermAction(
                                'addAdminUserManagementButton',
                                'Add', // Permission check for adding user management button
                            ),
                            css: 'prm-addAdminUserManagementButton',
                            width: screen == 'small' ? 0 : 150, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                if (this.getUrl()[0].page !== 'AdminUserManagement')
                                    this.show(
                                        'addAdminUserManagement/security.adminuser.addAdminUser', // Navigate to add user view
                                    );
                                else
                                    this.show(
                                        '/security.adminuser.addAdminUser', // Navigate to add user view
                                    );
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('adminUser:filter', [
                                    filterdata, // Trigger filter event with form data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button for second form
                    click: () => {
                        $$('myForm2').clear(); // Clear second form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button for second form
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('adminUser:filter', [filterdata]); // Trigger filter event with second form data
                        $$('filterPopup').hide(); // Hide filter popup
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Accordion starts collapsed
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section,
                                    accordion_section,
                                    buttons, // Include buttons in the accordion
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy', // Enable scrolling
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Include upper section and accordion
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Filters label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include accordion and buttons in the form
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Conditional rendering based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
